export class MerchantDM {
  constructor({
    name = "",
    description = "",
    description_ind = "",
    website = "",
    balance = 0,
    code = "",
  }) {
    this.name = name;
    this.description = description;
    this.description_ind = description_ind;
    this.website = website;
    this.balance = balance;
    this.code = code;
  }

  toJson() {
    return {
      name: this.name,
      description: this.description,
      description_ind: this.description_ind,
      website: this.website,
      balance: this.balance,
      code: this.code,
    };
  }

  static fromJson(json) {
    return new MerchantDM({
      name: json["name"],
      description: json["description"],
      description_ind: json["description_ind"],
      website: json["website"],
      balance: json["balance"],
      code: json["code"],
    });
  }
}
